export const marchAbbreviatedLowercase = "T1yPRe";
export default {marchAbbreviatedLowercase};